import { cn } from "@omni/utils/styles";

import { LinkComponentProps } from "./link.props";

const Link = ({ children, className, ...props }: LinkComponentProps) => {
    return (
        <a
            className={cn(
                "tw:text-information tw:bg-transparent tw:hover:underline",
                "tw:hover:text-information-focus",
                className
            )}
            {...props}
        >
            {children}
        </a>
    );
};

export { Link };
